// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function use() {
  var match = React.useState(function () {
        return false;
      });
  var setShow = match[1];
  var show = match[0];
  var toggleShow = function (param) {
    setShow(function (t) {
          return !t;
        });
  };
  React.useEffect((function () {
          var hide = function (param) {
            setShow(function (param) {
                  return false;
                });
          };
          if (show) {
            window.addEventListener("mousedown", hide);
          }
          return (function () {
                    if (show) {
                      window.removeEventListener("mousedown", hide);
                      return ;
                    }
                    
                  });
        }), [show]);
  return [
          show,
          toggleShow
        ];
}

export {
  use ,
}
/* react Not a pure module */
